<template>
  <v-container class="pa-0">
    <v-container class="wrapper pa-3">
      <v-container class="d-flex justify-start pa-0">
        <v-btn color="primary" outlined @click="openPanelDialog('add')">
          <span>{{ $t("add-new-panel") }}</span>
          <v-icon size="16" class="mr-1">mdi-plus</v-icon>
        </v-btn>
      </v-container>
      <v-container class="pa-0 mt-5 columns">
        <v-container
          class="pa-4 column-panel d-flex justify-space-between align-center mt-2"
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="d-flex align-center gap-3">
            <v-card-text class="pa-0 text-caption">{{ index + 1 }}</v-card-text>
            <v-card-text class="pa-0 text-body-2">{{ item.panel_name }}</v-card-text>
          </div>
          <div class="d-flex align-center gap-3">
            <v-card-text
              class="pa-0 text-body-2"
              :style="{ color: item.panel_status == 'active' ? '#137333' : '#ff5252' }"
            >
              {{ $t(item.panel_status) }}
            </v-card-text>
            <v-btn
              outlined
              color="primary"
              height="32"
              @click="openSyncPermission(item, index)"
              :disabled="syncingPanels.includes(index)"
            >
              {{
                syncingPanels.includes(index)
                  ? $t("synchronizing-products") + "..."
                  : $t("synchronize-products")
              }}
            </v-btn>
            <v-btn
              color="primary"
              outlined
              height="32"
              v-clipboard:copy="
                `https://integrator.abriron.com/api/sazito/webhook?key=${item.panel_token}`
              "
              @click="copied"
              :disabled="item.panel_token == null"
            >
              {{ $t("orderWebhook") }}
            </v-btn>
            <div @click="openPanelDialog('edit', item)">
              <my-icon
                :name="'edit-icon'"
                :width="16"
                :height="17"
                :stroke="'#000'"
                :cursor-pointer="true"
              />
            </div>
          </div>
        </v-container>
        <v-container class="d-flex justify-space-between pa-0 mt-10">
          <v-btn color="primary" height="32" @click="submit" :loading="loading">
            {{ $t("submit") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
    <v-dialog
      v-model="panelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="firstStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedPanel ? selectedPanel.panel_name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="panelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-cente gap-2">
            <v-text-field
              v-model="newPanel.panel_name"
              :label="$t('panel_name')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
            />
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 mx-0"
              style="width: 151px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPanel(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPanel == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPanel == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-btn
              color="primary"
              outlined
              height="32"
              @click="copyWebHook"
              :disabled="newPanel.panel_token == null"
            >
              {{ $t("orderWebhook") }}
            </v-btn>
          </v-container>
          <v-container class="pa-0 d-flex gap-2 mt-6">
            <v-text-field
              v-model="newPanel.configs.domain_address"
              :label="$t('domainName')"
              outlined
              height="32"
              dense
              style="width: 0"
              :rules="[(v) => !!v || $t('is-required')]"
              dir="ltr"
              @focus="isUserFocusOnDomain = true"
              @blur="resolveDomainPrefix"
              class="domain-input"
            >
              <template v-slot:prepend-inner>
                <v-card-text
                  :style="{ display: isUserFocusOnDomain ? 'block' : 'none' }"
                  class="text--secondary text-body-2 pa-0 mt-1"
                >
                  https://
                </v-card-text>
              </template>
            </v-text-field>
            <!-- <v-text-field
              v-model="newPanel.domain_address"
              :label="$t('domainName')"
              outlined
              height="32"
              dense
              style="width: 0;"
              :rules="[v => !!v || $t('is-required')]"
            /> -->
            <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.configs.sazito_token"
              :label="$t('apiKey')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mb-9 mt-10">
            <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.configs.currency_coefficient"
              :label="$t('currency_coefficient')"
              outlined
              height="32"
              dense
              :rules="[(v) => !!v || $t('is-required')]"
              type="number"
            />
            <!-- <v-text-field
              v-if="newPanel && newPanel.configs"
              v-model="newPanel.phone"
              :label="$t('phone-number')"
              outlined
              height="32"
              dense
              :rules="[v => !!v || $t('is-required')]"
            /> -->
            <div style="width: 60.5%"></div>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("invoice-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <v-select
              v-model="newPanel.configs.confirm_status"
              :label="$t('registerStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.configs.edit_status"
              :label="$t('editStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.configs.destroy_status"
              :label="$t('removeStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
            <v-select
              v-model="newPanel.configs.return_sell_status"
              :label="$t('returnSellStatus')"
              :items="statusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center justify-space-between mt-10">
            <div class="d-flex align-center gap-1">
              <v-btn color="primary" height="32" @click="nextStep">
                {{ $t("next-step") }}
              </v-btn>
              <v-btn color="secondary" outlined height="32" @click="panelDialog = false">
                {{ $t("cancel") }}
              </v-btn>
            </div>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="secondPanelDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="800"
    >
      <v-card class="pa-5">
        <v-form ref="secondStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">
              {{
                dialogType == "add"
                  ? $t("add-new-panel")
                  : $t("edit-panel") +
                    " " +
                    (selectedPanel ? selectedPanel.panel_name : "")
              }}
            </v-card-text>
            <v-icon size="20" @click="secondPanelDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("warehouse and branch settings")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="newPanel.configs.default_branch"
              :title="$t('defaultBranch')"
              type="branch"
              class="flex-fill"
            />
            <autocomplete
              v-model="newPanel.configs.seller_warehouse"
              :rules="[(v) => !!v || $t('is-required')]"
              :title="$t('entrepotToUse')"
              type="entrepot"
              class="flex-fill"
            />
          </v-container>
          <v-container class="d-flex align-center gap-3 pa-0 mb-7 mt-11">
            <v-card-text class="pa-0 text-body-2">{{
              $t("inventory-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusInventoryUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusInventoryUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusInventoryUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusInventoryUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
            <v-card-text class="pa-0 text-body-2">{{
              $t("fixed-price-update")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 150px"
            >
              <div
                v-for="(item, index) in activatorOptions"
                :key="index"
                @click="selectStatusPriceUpdate(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    selectedStatusPriceUpdate == item.value ? '#E5FEED' : '',
                  'border-color':
                    selectedStatusPriceUpdate == item.value ? '#0066ff' : 'silver',
                  color: selectedStatusPriceUpdate == item.value ? '#137333' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container class="pa-0 d-flex align-center justify-space-between">
            <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
              $t("payment-method")
            }}</v-card-text>
            <v-btn color="secondary" outlined @click="addNewPaymentMethod">
              {{ $t("add-new-payment-method") }}
              <v-icon size="20" class="ms-2">mdi-plus</v-icon>
            </v-btn>
          </v-container>
          <v-data-table
            :headers="headers"
            :items="paymentMethodsItems"
            :items-per-page="-1"
            hide-default-footer
            :height="isMobile || isTablet ? 265 : 200"
            fixed-header
            class="paymentTable"
          >
            <template v-slot:item.bank="{ item, index }">
              {{ item.bank.name }}
            </template>
            <template v-slot:item.method="{ item, index }">
              {{ $t(item.method) }}
            </template>
            <template v-slot:header.edit="{ header }">
              <v-container
                class="pa-0 d-flex align-center justify-space-between ma-0 gap-1"
              >
                {{ $t("delete all") }}
                <div style="cursor: pointer" @click="openDeleteDialog('all')">
                  <my-icon
                    :name="'trash-icon'"
                    :width="15"
                    :height="15"
                    :cursor-pointer="true"
                  />
                </div>
              </v-container>
            </template>
            <template v-slot:item.edit="{ item, index }">
              <div
                class="d-flex justify-center"
                style="cursor: pointer"
                @click="openDeleteDialog('single', item)"
              >
                <my-icon
                  :name="'trash-icon'"
                  :width="15"
                  :height="15"
                  :cursor-pointer="true"
                />
              </div>
            </template>
          </v-data-table>
          <v-container class="pa-0 d-flex justify-space-between mt-9">
            <div class="d-flex align-center gap-2">
              <v-btn color="primary" height="32" @click="checkValidation">
                {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
              </v-btn>
              <v-btn color="primary" height="32" outlined @click="prevStep">
                {{ $t("previus-step") }}
              </v-btn>
              <v-btn
                color="secondary"
                outlined
                height="32"
                @click="secondPanelDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </div>
            <v-btn color="error" outlined height="32" @click="openDeleteDialog('panel')">
              <span class="ml-1">{{ $t("delete-panel") }}</span>
              <my-icon
                :name="'trash-icon'"
                :width="15"
                :height="15"
                :fill="'#ff5252'"
                :cursor-pointer="true"
              />
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="paymentDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="500"
    >
      <v-card class="pa-5">
        <v-form ref="thirdStep" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-body-1">{{
              $t("add-new-payment-method")
            }}</v-card-text>
            <v-icon size="20" @click="paymentDialog = false">mdi-close</v-icon>
          </v-container>
          <v-card-text class="pa-0 text-body-2 mt-7 mb-4">{{
            $t("general-setting")
          }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-2">
            <autocomplete
              v-model="paymentMethods.bank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
              :rules="[(v) => !!v || $t('is-required')]"
              :outlined="true"
              :value="paymentMethods.bank"
            />
            <v-select
              v-model="paymentMethods.method"
              :label="$t('method')"
              :items="paymentMethodsOptions"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-container>
          <v-container class="pa-0 d-flex align-center gap-2 mt-12">
            <v-btn color="primary" height="32" @click="addPaymentMethod">
              {{ $t("confirm") }}
            </v-btn>
            <v-btn color="secondary" outlined height="32" @click="paymentDialog = false">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">
          {{
            deleteMode == "all"
              ? $t("are you sure you want to delete all items?")
              : deleteMode == "single"
              ? $t("Are you sure you want to delete this item ?")
              : deleteMode == "panel"
              ? $t("do you want to delete this panel ?")
              : ""
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex align-center gap-2 mt-6">
          <v-btn color="error" height="32" @click="remove" :loading="loading">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="secondary" height="32" outlined>
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSyncPermission"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from sazito")
          }}</v-card-text>
          <v-icon size="20" @click="productSyncPermission = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2 my-8" style="line-height: 25px">
          {{ $t("do you want to sync the panel product information ?") }}
          <br />
          {{ panelName }}
          <br />
          {{ $t("are you sure ?") }}
        </v-card-text>
        <v-container class="pa-0 d-flex gap-2">
          <v-btn color="primary" height="32" @click="synchronization">
            {{ $t("yes, synchronize") }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            height="32"
            @click="productSyncPermission = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="productSync"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from sazito")
          }}</v-card-text>
          <v-icon size="20" @click="productSync = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-5">
          <img src="@/assets/integrators/sync-sazito.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2 text-center" style="line-height: 25px">
            {{ $t("we are syncing panel product information") }}
            {{ panelName }}
            {{ $t("from sazito") }}
            {{ $t("this process may take time. Please be patient.") }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="syncSuccessDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-card-text class="pa-0 text-body-2">{{
            $t("receive product information from digikala")
          }}</v-card-text>
          <v-icon size="20" @click="syncSuccessDialog = false">mdi-close</v-icon>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center my-7">
          <img v-if="isUserGaveAccess" src="@/assets/integrators/sync-success.png" />
          <img v-else src="@/assets/integrators/sync-failed.png" />
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center">
          <v-card-text class="pa-0 text-body-2">
            {{
              isUserGaveAccess
                ? $t("your connection has been established successfully.")
                : $t(
                    "unfortunately your connection has not been established successfully."
                  )
            }}
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : ''"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import MyIcon from "../../components/general/icon/MyIcon.vue";
import General from "../../../../Mixins/general";

export default {
  data() {
    return {
      panelDialog: false,
      secondPanelDialog: false,
      paymentDialog: false,
      selectedStatusPanel: null,
      selectedStatusInventoryUpdate: null,
      selectedStatusPriceUpdate: null,
      snakbar: false,
      snakbarText: null,
      snakbarColor: null,
      dialogType: null,
      valid: true,
      selectedIndex: null,
      deleteDialog: false,
      entrepot: null,
      items: [],
      statusItems: [
        {
          value: "started",
          text: this.$t("sazito-started"),
        },
        {
          value: "shipping",
          text: this.$t("sazitoShipping"),
        },
        {
          value: "shipped",
          text: this.$t("sazitoShipped"),
        },
        {
          value: "complete",
          text: this.$t("sazitoComplete"),
        },
        {
          value: "cancelled",
          text: this.$t("sazitoCancelled"),
        },
      ],
      userInfo: null,
      loading: false,
      newPanel: {
        id: null,
        type: "sazito",
        phone: null,
        abr_name: null,
        abr_token: null,
        panel_name: null,
        panel_status: null,
        panel_token: null,
        configs: Object.assign(
          {},
          {
            domain_address: null,
            currency_coefficient: null,
            sazito_token: null,
            default_branch: null,
            confirm_status: null,
            edit_status: null,
            destroy_status: null,
            return_sell_status: null,
            seller_warehouse: null,
            inventory_update: null,
            price_update: null,
          }
        ),
        payments: [],
      },
      paymentMethods: {
        bank: null,
        method: null,
      },
      paymentMethodsOptions: [
        // add trobpay
        {
          value: "trobpay",
          text: this.$t("trobpay"),
        },
        {
          value: "ayriapayment",
          text: this.$t("ayriapayment"),
        },
        {
          value: "azkipayment",
          text: this.$t("azkipayment"),
        },
        {
          value: "bazarpayment",
          text: this.$t("bazarpayment"),
        },
        {
          value: "cardtocardpayment",
          text: this.$t("cardtocardpayment"),
        },
        {
          value: "digipaypayment",
          text: this.$t("digipaypayment"),
        },
        {
          value: "freepayment",
          text: this.$t("freepayment"),
        },
        {
          value: "mellatpayment",
          text: this.$t("mellatpayment"),
        },
        {
          value: "ozonpayment",
          text: this.$t("ozonpayment"),
        },
        {
          value: "paymentinplacepayment",
          text: this.$t("paymentinplace"),
        },
        {
          value: "paypingpayment",
          text: this.$t("paypingpayment"),
        },
        {
          value: "pecpayment",
          text: this.$t("pecpayment"),
        },
        {
          value: "sadadpayment",
          text: this.$t("sadadpayment"),
        },
        {
          value: "seppayment",
          text: this.$t("seppayment"),
        },
        {
          value: "snapppayment",
          text: this.$t("snapppayment"),
        },
        {
          value: "tarapayment",
          text: this.$t("tarapayment"),
        },
        {
          value: "tomanpayment",
          text: this.$t("tomanpayment"),
        },
        {
          value: "uppayment",
          text: this.$t("uppayment"),
        },
        {
          value: "vandarpayment",
          text: this.$t("vandarpayment"),
        },
        {
          value: "zarinpalpayment",
          text: this.$t("zarinpalpayment"),
        },
        {
          value: "zibalpayment",
          text: this.$t("zibalpayment"),
        },
        {
          value: "zifypayment",
          text: this.$t("zifypayment"),
        },
      ],
      headers: [],
      paymentMethodsItems: [],
      deleteMode: null,
      newSelectedMethod: null,
      selectedPanel: null,
      isUserFocusOnDomain: false,
      productSyncPermission: false,
      panelName: null,
      productSync: null,
      selectedSyncPanel: null,
      syncingPanels: [],
      syncSuccessDialog: false,
      isUserGaveAccess: false,
      wantedSyncPanel: null,
    };
  },
  mixins: [General],
  methods: {
    copyWebHook() {
      const text = `https://integrator.abriron.com/api/sazito/webhook?key=${this.newPanel.panel_token}`;
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.copied();
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    },
    fetchPanelList() {
      var app = this;
      app.$axios
        .get(this.$apipoint + "config/sazito/list")
        .then((r) => {
          this.items = r.data;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    openPanelDialog(type, selectedItem) {
      this.panelDialog = true;
      if (type == "add") {
        this.clearForm();
        this.newPanel.configs.currency_coefficient = 1;
        this.dialogType = "add";
      }
      if (type == "edit" && selectedItem) {
        this.dialogType = "edit";
        this.isUserFocusOnDomain = true;
        this.selectedPanel = selectedItem;
        this.newPanel.panel_token = selectedItem.panel_token;
        //put inputs in forms
        this.newPanel = {
          id: selectedItem.id,
          type: "sazito",
          phone: selectedItem.phone,
          abr_name: this.userInfo?.init?.abrName,
          abr_token: this.userInfo?.token,
          panel_name: selectedItem.panel_name,
          panel_status: selectedItem.panel_status,
          panel_token: selectedItem.panel_token,
          configs: {
            domain_address: selectedItem.configs.domain_address,
            currency_coefficient: selectedItem.configs.currency_coefficient,
            sazito_token: selectedItem.configs.sazito_token,
            default_branch: selectedItem.configs.default_branch,
            confirm_status: selectedItem.configs.confirm_status,
            edit_status: selectedItem.configs.edit_status,
            destroy_status: selectedItem.configs.destroy_status,
            return_sell_status: selectedItem.configs.return_sell_status,
            seller_warehouse: selectedItem.configs.seller_warehouse,
            inventory_update: selectedItem.configs.inventory_update,
            price_update: selectedItem.configs.price_update,
          },
          payments: selectedItem.payments,
        };
        this.selectedStatusPanel = selectedItem.panel_status;
        this.selectedStatusInventoryUpdate = selectedItem.configs.inventory_update;
        this.selectedStatusPriceUpdate = selectedItem.configs.price_update;

        //put payments in data table
        this.paymentMethodsItems = this.newPanel.payments;

        this.selectedIndex = this.items.findIndex(
          (item) => item.configs.sazito_token == selectedItem.configs.sazito_token
        );
        /* console.log('selected index' + this.selectedIndex) */
      }
    },
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
      this.newPanel.panel_status = this.selectedStatusPanel;
    },
    selectStatusInventoryUpdate(item) {
      this.selectedStatusInventoryUpdate = item.value;
      this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate;
    },
    selectStatusPriceUpdate(item) {
      this.selectedStatusPriceUpdate = item.value;
      this.newPanel.configs.price_update = this.selectedStatusPriceUpdate;
    },
    nextStep() {
      if (this.$refs.firstStep.validate()) {
        this.panelDialog = false;
        this.secondPanelDialog = true;
        if (this.dialogType == "add") {
          this.selectedStatusInventoryUpdate = "active";
          this.selectedStatusPriceUpdate = "active";
          this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate;
          this.newPanel.configs.price_update = this.selectedStatusPriceUpdate;
        }
      }
    },
    prevStep() {
      this.secondPanelDialog = false;
      this.panelDialog = true;
    },
    checkValidation() {
      if (this.$refs.secondStep.validate() && this.dialogType == "add") {
        this.addPanel();
      }
      if (this.$refs.secondStep.validate() && this.dialogType == "edit") {
        this.editPanel();
      }
    },
    addPanel() {
      const sameObject = this.items.some(
        (item) => item.configs.sazito_token == this.newPanel.configs.sazito_token
      );
      if (!sameObject) {
        // add columns (show)
        this.items.push(this.newPanel);
        this.secondPanelDialog = false;
        /* console.log('items after add' + JSON.stringify(this.items)) */
      } else {
        this.snakbarText = this.$t("duplicate digikala token");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    editPanel() {
      // edit column (show)
      this.items.splice(this.selectedIndex, 1, this.newPanel);
      this.secondPanelDialog = false;
      /* console.log('items after edit' + JSON.stringify(this.items)) */
    },
    clearForm() {
      this.newPanel = {
        id: null,
        type: "sazito",
        phone: null,
        abr_name: this.userInfo?.init?.abrName,
        abr_token: this.userInfo?.token,
        panel_name: null,
        panel_status: "active",
        panel_token: null,
        configs: Object.assign(
          {},
          {
            domain_address: null,
            currency_coefficient: 1,
            sazito_token: null,
            default_branch: null,
            confirm_status: null,
            edit_status: null,
            destroy_status: null,
            return_sell_status: null,
            seller_warehouse: null,
            inventory_update: "active",
            price_update: "active",
          }
        ),
        payments: [],
      };
      // reset toggle button
      this.selectedStatusPanel = "active";
      this.selectedStatusInventoryUpdate = "active";
      this.selectedStatusPriceUpdate = "active";

      this.newPanel.panel_status = this.selectedStatusPanel;
      this.newPanel.configs.inventory_update = this.selectedStatusInventoryUpdate;
      this.newPanel.configs.price_update = this.selectedStatusPriceUpdate;

      // reset form
      if (this.$refs.firstStep && this.$refs.secondStep && this.$refs.thirdStep) {
        this.$refs.firstStep.reset();
        this.$refs.secondStep.reset();
        this.$refs.thirdStep.reset();
      }

      this.paymentMethodsItems = [];
      this.newPanel.payments = [];
    },
    addNewPaymentMethod() {
      this.paymentDialog = true;
    },
    addPaymentMethod() {
      this.paymentMethodsItems.push(this.paymentMethods);
      /* console.log('1' + JSON.stringify(this.paymentMethodsItems)) */

      this.newPanel.payments = this.paymentMethodsItems;
      /* console.log('2' + JSON.stringify(this.paymentMethodsItems)) */

      /* console.log('newpanel after add'+ JSON.stringify(this.newPanel)) */
      this.paymentDialog = false;
      this.paymentMethods = {
        bank: null,
        method: null,
      };
      // reset form
      this.$refs.thirdStep.reset();
      /* console.log('table after add' + JSON.stringify(this.paymentMethodsItems)) */
    },
    openDeleteDialog(type, selectedMethod) {
      if (type == "all") {
        this.deleteMode = "all";
        this.deleteDialog = true;
      }
      if (type == "single" && selectedMethod != null) {
        this.deleteMode = "single";
        this.deleteDialog = true;
        this.newSelectedMethod = selectedMethod;
        /* console.log(JSON.stringify(this.newSelectedMethod)) */
      }
      if (type == "panel") {
        if (this.dialogType == "add") {
          this.secondPanelDialog = false;
          this.clearForm();
        }
        if (this.dialogType == "edit") {
          this.deleteMode = "panel";
          this.deleteDialog = true;
        }
      }
    },
    submit() {
      // post api
      this.loading = true;
      var app = this;
      app.$axios
        .post(this.$apipoint + "config/sazito/store", this.items)
        .then((r) => {
          this.loading = false;
          this.snakbarText = this.$t("new panel successfully added");
          this.snakbarColor = "green";
          this.snakbar = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    remove() {
      if (this.deleteMode == "all") {
        this.paymentMethodsItems = [];
        this.newPanel.payments = [];
        this.deleteDialog = false;
      }
      if (this.deleteMode == "single") {
        const indexTable = this.paymentMethodsItems.findIndex(
          (item) =>
            item.method == this.newSelectedMethod.method &&
            item.bank.name == this.newSelectedMethod.bank.name
        );
        if (indexTable != -1) {
          this.paymentMethodsItems.splice(indexTable, 1);
        }
        const indexPanel = this.newPanel.payments.findIndex(
          (item) =>
            item.method == this.newSelectedMethod.method &&
            item.bank.name == this.newSelectedMethod.bank.name
        );
        if (indexPanel != -1) {
          this.newPanel.payments.splice(indexPanel, 1);
        }
        this.deleteDialog = false;
      }
      if (this.deleteMode == "panel") {
        this.deletePanel();
      }
    },
    deletePanel() {
      // delete api
      this.loading = true;
      const id = this.items[this.selectedIndex].id;
      /* console.log(id) */
      if (id != null) {
        var app = this;
        app.$axios
          .delete(this.$apipoint + `config/destroy/${id}`)
          .then((r) => {
            if (r.data.status == "success") {
              this.loading = false;
              this.items.splice(this.selectedIndex, 1);
              this.deleteDialog = false;
              this.panelDialog = false;
              this.secondPanelDialog = false;
              this.snakbarText = this.$t("your panel removed successfully");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          });
      } else {
        this.items.splice(this.selectedIndex, 1);
        this.panelDialog = false;
        this.secondPanelDialog = false;
        this.loading = false;
        this.deleteDialog = false;
        this.snakbarText = this.$t("your panel removed successfully");
        this.snakbarColor = "red";
        this.snakbar = true;
      }
    },
    resolveDomainPrefix() {
      if (this.isUserFocusOnDomain && this.newPanel.configs.domain_address.length > 0) {
        this.isUserFocusOnDomain = true;
      }
      if (this.isUserFocusOnDomain && this.newPanel.configs.domain_address.length == 0) {
        this.isUserFocusOnDomain = false;
      }
    },
    openSyncPermission(item, index) {
      var app = this;
      app.$axios
        .get(this.$apipoint + "config/sazito/list")
        .then((r) => {
          this.items = r.data;
          this.wantedSyncPanel = this.items.find(
            (obj) =>
              obj.panel_name == item.panel_name && obj.panel_status == item.panel_status
          );
          console.log(this.wantedSyncPanel.panel_token);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
      this.productSyncPermission = true;
      this.panelName = item.panel_name;
      this.selectedSyncPanel = index;
    },
    synchronization() {
      // call api
      this.pullingProduct();
      this.productSyncPermission = false;
      this.productSync = true;

      if (!this.syncingPanels.includes(this.selectedSyncPanel)) {
        this.syncingPanels.push(this.selectedSyncPanel);
      }
    },
    pullingProduct() {
      var app = this;
      app.$axios
        .post("https://integrator.abriron.com/api/" + "products/sazito/pulling", {
          panel_token: this.wantedSyncPanel.panel_token,
          url: this.wantedSyncPanel.configs.domain_address,
        })
        .then((r) => {
          if (r.data && r.data.error) {
            this.snakbar = true;
            this.snakbarText = r.data.error;
            this.snakbarColor = "red";
          }
        })
        .catch((error) => {
          const serverError = error.response?.data?.error || "خطای ناشناخته از سمت سرور";
          this.snakbar = true;
          this.snakbarText = serverError;
          this.snakbarColor = "red";
        });
    },
  },
  mounted() {
    this.fetchPanelList();
    this.userInfo = JSON.parse(localStorage.getItem("token"));
  },
  components: {
    MyIcon,
  },
  computed: {
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    invoiceOptions() {
      return [
        { label: this.$t("registration-of-returned-invoice"), value: "register" },
        { label: this.$t("delete-invoice"), value: "delete" },
      ];
    },
    webhookUrl() {
      return `https://integrator.abriron.com/api/sazito/webhook?key=${this.newPanel.panel_token}`;
    },
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val?.init) {
          this.newPanel.abr_name = val.init.abrName || null;
          this.newPanel.abr_token = val.token || null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.headers = [
      {
        text: this.$t("bank-or-fund"),
        align: "start",
        sortable: false,
        value: "bank",
        width: "40%",
      },
      {
        text: this.$t("payment-method"),
        align: "start",
        sortable: false,
        value: "method",
        width: "40%",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
        width: "10%",
      },
    ];
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #fcfcfc;
}
.wrapper .columns .column-panel {
  border: 1px solid silver;
  border-radius: 4px;
}
.v-card__text {
  width: auto;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
::v-deep .v-data-table.paymentTable .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.paymentTable {
  border: 1px solid silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.paymentTable .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  /* background-color: #eeeeee; */
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
  border-left: 1px solid silver;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.paymentTable > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.paymentTable
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
.domain-input.v-text-field ::v-deep .v-label.v-label--active {
  right: 0px !important;
}
::v-deep .v-input__prepend-inner {
  position: absolute;
  left: 9px;
  direction: ltr;
}
.domain-input.v-text-field
  ::v-deep
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input {
  margin-left: 48px;
}
</style>
